import { Button } from "@/components/ui/button";

const SUCCESS_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a48e3043-66a2-447d-85d7-dae1e1fd5839/images/4d255d5d4e3ce8edd1e142b402b950700b55530754ee94e74680fb2f704c8f4b.png";

export const SuccessScreen = ({ result, content = {}, onAnother }) => {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <div className="mx-auto flex max-w-2xl flex-col items-center px-6 py-16 text-center">
        <div className="animate-float-up">
          <img
            src={SUCCESS_IMG}
            alt="Golden theater ticket"
            className="mx-auto mb-8 w-64 max-w-full drop-shadow-xl"
            data-testid="success-image"
          />
        </div>
        <h1 className="font-heading text-4xl font-semibold text-[#3556A5] sm:text-5xl" data-testid="success-heading">
          {content.success_heading || "Thank you,"} {result.camper_first_name}!
        </h1>
        <p className="mt-4 text-lg text-slate-700">
          {content.success_message || "Your audition has been submitted."}
        </p>
        <p className="mt-3 text-base text-slate-600">
          {content.success_subtext || "Our directors will review your video and be in touch with your parent/guardian."}
        </p>
        <p className="mt-6 font-heading text-2xl font-semibold text-[#C9A227]">{content.success_closing || "Break a leg! 🎭"}</p>

        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <Button
            onClick={onAnother}
            data-testid="submit-another-btn"
            className="rounded-full bg-[#3556A5] px-8 py-6 text-base font-semibold text-white hover:bg-[#2B4584]"
          >
            Submit Another Audition
          </Button>
          <Button
            variant="outline"
            onClick={onAnother}
            data-testid="back-to-home-btn"
            className="rounded-full border-slate-300 px-8 py-6 text-base"
          >
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SuccessScreen;
